<template>
  <div class="min-h-screen">
    <NuxtLayout>
      <NuxtPage />
    </NuxtLayout>
  </div>
</template>

<script setup lang="ts"></script>

<style>
/* Global CSS (Tailwind zaten varsa çoğu gereksiz olur) */
</style>
